import {
  createAction,
  createAsyncThunk,
  createEntityAdapter,
  createReducer,
  EntityState,
} from "@reduxjs/toolkit";

import { getGoodsCate } from "api/goods";
import LoadingStatus from "libs/loading-status";
import { RootState } from "store";
import GoodsCategory from "./GoodsCategory";

export const fetchGoodsCategory = createAsyncThunk(
  "productPayment/fetchCategory",
  () => {
    return getGoodsCate();
  }
);

export const selectCategory = createAction<{ id: string }>(
  "productPayment/selectMenu"
);

const categoryEntities = createEntityAdapter<GoodsCategory>({
  selectId: (category: GoodsCategory) => category.cateTID,
});

export interface ProductPaymentCategoryState
  extends EntityState<GoodsCategory> {
  loadingStatus: LoadingStatus;
  selectedCategory: string | null;
}

const initialState: ProductPaymentCategoryState =
  categoryEntities.getInitialState({
    loadingStatus: LoadingStatus.IDLE,
    selectedCategory: null,
  });

export const categoryReducer = createReducer(initialState, (builder) => {
  builder.addCase(fetchGoodsCategory.pending, (state) => {
    state.loadingStatus = LoadingStatus.PENDING;
    categoryEntities.removeAll(state);
  });
  builder.addCase(fetchGoodsCategory.fulfilled, (state, action) => {
    categoryEntities.addMany(state, action.payload);
    state.loadingStatus = LoadingStatus.SUCCEEDED;
    if (action.payload.length > 0) {
      state.selectedCategory = action.payload[0].cateTID;
    }
  });
  builder.addCase(fetchGoodsCategory.rejected, (state) => {
    state.loadingStatus = LoadingStatus.FAILED;
  });
  builder.addCase(selectCategory, (state, action) => {
    state.selectedCategory = action.payload.id;
  });
});

export const getCategoryState = (state: RootState) =>
  state.productPayment.category;
export const getEntities = (state: RootState) =>
  getCategoryState(state).entities;
export const getLoadingStatus = (state: RootState) =>
  getCategoryState(state).loadingStatus;
export const getCategoryList = (state: RootState): GoodsCategory[] =>
  Object.values(getEntities(state)) as GoodsCategory[];
export const getCategoryByName = (
  state: RootState,
  props: { categoryName: string }
) =>
  getCategoryList(state).find(
    (category) => category.cateName === props.categoryName
  );
export const getSelectedCategory = (state: RootState) => {
  const categoryState = getCategoryState(state);
  return categoryState.selectedCategory
    ? categoryState.entities[categoryState.selectedCategory]
    : null;
};
